import request from '@/request'

// 是否中奖
export const isAward = data => {
  return request({
    url: 'mobile_LotteryBase/isAward.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}

export const add = data => {
  return request({
    url: 'mobile_PartyUser/add.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}

export const updateuser = data => {
  return request({
    url: 'mobile_LotteryBase/updateuser.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}

export const relation = data => {
  return request({
    url: 'mobile_LotteryBase/relation.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}

export const save = data => {
  return request({
    url: 'mobile_extExaminfo/save.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}

export const getExam = data => {
  return request({
    url: 'mobile_extExaminfo/getExam.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 获取福卡
export const addCard = data => {
  return request({
    url: '/mobile_CardYz_Vipwd/addCard.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 抽奖
export const award = data => {
  return request({
    url: 'mobile_LotteryBase/award.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}

export const getMyCard = data => {
  return request({
    url: '/mobile_CardYz_Vipwd/getMyCard.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 兑换福袋
export const addExchange = data => {
  return request({
    url: '/mobile_CardYz_Vipwd/addExchange.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}

export const addAnswer = data => {
  return request({
    url: '/mobile_CardYz_Vipwd/addAnswer.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}

export const checkExchange = data => {
  return request({
    url: '/mobile_CardYz_Vipwd/checkExchange.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 赠送福卡
export const presentMyCard = data => {
  return request({
    url: '/mobile_CardYz_Vipwd/presentMyCard.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
